var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	4492: {
		fallback: () => (__webpack_require__.e(856).then(() => (() => (__webpack_require__(856))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^2.5.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "tailwind-merge",

	},
	3945: {
		fallback: () => (Promise.all([__webpack_require__.e(3556), __webpack_require__.e(5618)]).then(() => (() => (__webpack_require__(5618))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.13",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "zustand",

	},
	1175: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(6540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	8393: {
		fallback: () => (__webpack_require__.e(3342).then(() => (() => (__webpack_require__(961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	63: {
		fallback: () => (Promise.all([__webpack_require__.e(1409), __webpack_require__.e(3556)]).then(() => (() => (__webpack_require__(1409))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-toastify",

	},
	198: {
		fallback: () => (Promise.all([__webpack_require__.e(3895), __webpack_require__.e(3556), __webpack_require__.e(8393)]).then(() => (() => (__webpack_require__(3895))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.4.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "radix-ui",

	},
	6470: {
		fallback: () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(8393)]).then(() => (() => (__webpack_require__(2648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.22.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	8055: {
		fallback: () => (__webpack_require__.e(8980).then(() => (() => (__webpack_require__(8980))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"3556": [
		1175
	],
	"3945": [
		3945
	],
	"4492": [
		4492
	],
	"6324": [
		63,
		198,
		6470,
		8055
	],
	"8393": [
		8393
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}